import styled from 'styled-components/macro'

import { EmptyState } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import IllustrationMagnifyingGlass from 'core/ui/assets/illustration-magnifying-glass.svg'

import { type BidState } from '../domain/RfpSummary'
import { formatRfpHistoryEmptyStateMessage } from '../presenters/rfpHistoryPresenter'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getToken('space-3xl')};
`

type EmptyRfpHistoryStateProps = {
  bidState?: BidState
}

export function EmptyRfpHistoryState({ bidState }: EmptyRfpHistoryStateProps) {
  const { title, description } = formatRfpHistoryEmptyStateMessage(bidState)

  return (
    <Wrapper>
      <EmptyState
        title={title}
        description={description}
        illustration={IllustrationMagnifyingGlass}
        variant="page"
      />
    </Wrapper>
  )
}
